import Qs from "qs";
import { Builder } from "logic/rest/FetchProvider";
import * as URLUtils from "util/URLUtils";
const request = (method, path, body, query, headers) => {
  const pathWithQueryParameters = Object.entries(query).length > 0 ? `${path}?${Qs.stringify(query, { indices: false })}` : path;
  const builder = new Builder(method, URLUtils.qualifyUrl(pathWithQueryParameters)).json(body);
  const builderWithHeaders = Object.entries(headers).reduce(
    (prev, [key, value]) => prev.setHeader(key, value),
    builder
  );
  return builderWithHeaders.build();
};
export default request;
